<template>
  <apex-chart type="donut" :height="height" :series="series" :options="chartOptions" />
</template>

<script>
import ApexChart from 'vue-apexcharts'

export default {
  components: { ApexChart },

  props: {
    // [{ label, value }]
    segments: { type: Array, required: true },
    colors: { type: Array, default: () => ['#a1c2fa', '#63a8ff', '#214773', '#1c78c9'] },
    unit: { type: String, default: '' },
    height: { type: [Number, String], default: 260 }
  },

  computed: {
    series () {
      return this.segments.map(({ value }) => Number(value) || 0)
    },

    chartOptions () {
      return {
        chart: { fontFamily: 'inherit' },
        labels: this.segments.map(({ label }) => label),
        colors: this.colors,
        legend: { position: 'bottom', fontSize: '12px' },
        dataLabels: { formatter: val => `${Math.round(val)}%` },
        tooltip: { y: { formatter: val => `${Math.round(val)}${this.unit ? ' ' + this.unit : ''}` } }
      }
    }
  }
}
</script>
